import { Waiting } from '@/components/Waiting';
import { useT } from '@/i18n/LocaleProvider';

/**
 * A page whose code is still arriving: the route-pending marker (`isContentPending`) with the waiting
 * study, which names its step at 2 s and the slow line at 10 s (F-0578 WAIT-8, T-0670). A chunk that
 * fails is the route error screen's, with its own retry.
 */
export function RoutePendingFrame() {
  const t = useT();
  return (
    <div data-route-pending="" className="grid min-h-[40vh] place-items-center">
      <Waiting
        size="section"
        label={t('navigation.sidebar.loadingPage')}
        caption={t('navigation.sidebar.loadingThisPage')}
      />
    </div>
  );
}
